import { Component, Input } from '@angular/core';
import { PaymentService } from '../../../../common/service/payment.service';
import { FormCompleteComponent } from '../complete.component';

@Component({
  selector: 'complete-mmdirect',
  templateUrl: './complete.component.mmdirect.html',
})
export class FormCompleteComponentMMDirect extends FormCompleteComponent {
  constructor(protected paymentService: PaymentService) {
    super(paymentService);
  }
}
